import { Button, Card, CardActions, CardContent, CardHeader, TextField, Typography } from "@mui/material";
import { useState } from "react";
import Modal from "../../../../components/modal";
import { Movimentacao } from "../../mov.model";


interface ObservacaoModalProps {
    confirmar: (obs: string) => any,
    handleClose: () => any
    show: boolean
    obsValue:string
}
export const ObservacaoModal = (props: ObservacaoModalProps) => {
    const { confirmar, handleClose, show, obsValue } = props

    const handleConfirmar = (obs:string) => {
        confirmar(obs);
        handleClose();
    }

    const Content = () => {
        const [obs, setObs] = useState(obsValue)
        
        return (
            <Card>
                <CardHeader title={"Informar Observações"} />
                <CardContent sx={{display:"flex"}}>
                    <TextField
                        autoFocus
                        fullWidth
                        multiline
                        maxRows={4}
                        value={obs}
                        onChange={(ev) => {
                            setObs(ev.target.value)
                            ev.preventDefault();
                        }}
                    />

                </CardContent>
                <CardActions sx={{alignContent:"center"}}>
                    <Button variant="contained" color="success" onClick={()=>handleConfirmar(obs)}>
                        Concluir
                    </Button>
                </CardActions>
            </Card>
        )
    }

    return (
        <Modal
            component={
                <Content />
            }
            handleClose={handleClose}
            open={show}
            width="xs"
            heigth="auto"
            handleOnKeyDown={() => { }}
        />
    )
}

interface CardObsProps {
    mov: Movimentacao
    mutatorLocal:(value:string, fieldName:string) => any
    setShowObsModal:(value:boolean) => any
    showObsModal:boolean
}

export const CardObs = (props:CardObsProps) => {
    const { mov, mutatorLocal, setShowObsModal, showObsModal } = props
    return (
        <>
            {mov.obs && (
                <Card >
                    <CardHeader disableTypography title={<Typography variant="caption" >Observações</Typography>} />
                    <CardContent>
                        {mov.obs}
                    </CardContent>
                </Card>
            )}
            <ObservacaoModal
                confirmar={(obs) => mutatorLocal(obs, "obs")}
                handleClose={() => setShowObsModal(false)}
                show={showObsModal}
                obsValue={mov.obs}
            />
        </>
    )
}